import closeDialogListener from 'foundation/js/utils/closeDialogListener'
import { useMenuStore } from 'stores/menu.store'
import { computed } from 'vue'

export default {
    name: 'MenuSecondary',
    setup() {
        const store = useMenuStore()
        const activeMenu = computed(() => store.activeMenu)
        const ACTIVE__ACCORDION_MODIFIER = 'be-menu-secondary__menu-list-item--active'

        const handleMenuItem = (e, menuItemToActivate) => {
            store.setActiveMenuNoOverlay(menuItemToActivate)
            closeDialogListener(['be-menu-secondary__dropdown', 'be-menu-secondary__menu-item'], () => store.closeMenu())
        }

        const getClassnameModifiers = (menuItemToActivate) => (activeMenu.value === menuItemToActivate ? ACTIVE__ACCORDION_MODIFIER : '')

        const isActiveMenu = function (activeMenuName, onlyBoolean) {
            const state = activeMenuName === activeMenu.value ? 'be-menu-secondary__dropdown--shown' : ''
            return onlyBoolean ? !!state : state
        }

        return {
            handleMenuItem,
            isActiveMenu,
            getClassnameModifiers,
        }
    },
}
